import { string } from 'prop-types';
import {
  LOGIN_ERROR,
  LOGIN_START,
  LOGIN_SUCCESS,
  REGISTER_ERROR,
  REGISTER_START,
  REGISTER_SUCCESS,
  AIRBNB_LOGIN_START,
  AIRBNB_CAPTCHA_VERIFICATION_REQUESTED,
  AIRBNB_CAPTCHA_VERIFICATION_WAITING,
  AIRBNB_CAPTCHA_VERIFICATION_SUCCESS,
  AIRBNB_EMAIL_VERIFICAION_START,
  AIRBNB_EMAIL_VERIFICAION_SUCCESS,
  AIRBNB_LOGIN_SUCCESS,
  AIRBNB_LOGIN_ERROR,
  SET_USER_INFO_RATE_LIMITED,
} from './types';

const initialState = {
  loading: false,
  error: false,
  reason : null,
  isRateLimited: false,
};

const airbnbAuthState = {
  loading: false,
  action: '',
  captcha_url: '',
  airlock_id: '',
  user_id: '',
  error: '',
  reason: null,
};

export const AuthReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    default:
      return state;
    case LOGIN_START:
      return { ...state, loading: true, error: payload.error };
    case LOGIN_SUCCESS:
      return { ...state, loading: false, error: payload.error };
    case LOGIN_ERROR:
      return { ...state, loading: false, error: payload.error };
    case REGISTER_START:
      return { ...state, loading: true, error: payload.error };
    case REGISTER_SUCCESS:
      return { ...state, loading: false, error: payload.error };
    case REGISTER_ERROR:
      return { ...state, loading: false, error: payload.error, reason: payload.reason};
    case SET_USER_INFO_RATE_LIMITED:
      return { ...state, isRateLimited: payload };
  }
};

export const AirbnbAuthReducer = (state = airbnbAuthState, { type, payload }) => {
  switch (type) {
    default:
      return state;
    case AIRBNB_LOGIN_START:
      return { ...state, loading: true };
    case AIRBNB_CAPTCHA_VERIFICATION_REQUESTED:
      return {
        ...state,
        loading: false,
        action: payload.action,
        captcha_url: payload.captcha_url,
        airlock_id: payload.airlock_id,
        user_id: payload.user_id,
      };
    case AIRBNB_CAPTCHA_VERIFICATION_WAITING:
      return {
        ...state,
        loading: true,
      };
    case AIRBNB_CAPTCHA_VERIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        action: payload.action,
        captcha_url: payload.captcha_url,
        airlock_id: payload.airlock_id,
        user_id: payload.user_id,
      };
    case AIRBNB_EMAIL_VERIFICAION_START:
      return { ...state, loading: true };
    case AIRBNB_EMAIL_VERIFICAION_SUCCESS:
      return { ...state, loading: false, action: payload.action };
    case AIRBNB_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        action: payload.action,
      };
    case AIRBNB_LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        action: payload.action,
        error: payload.error,
      };
  }
};
